import { Component, signal } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { CardsRunsTabComponent } from './runs-tab/cards-runs-tab.component';
import { CardsStudioTabComponent } from './studio-tab/cards-studio-tab.component';
import { CardsSpawnsTabComponent } from './spawns-tab/cards-spawns-tab.component';
import { CardsCalendarTabComponent } from './calendar-tab/cards-calendar-tab.component';
import { CardsSeedsTabComponent } from './seeds-tab/cards-seeds-tab.component';
import { CardsBattlesTabComponent } from './battles-tab/cards-battles-tab.component';
import { CardsSubmissionsTabComponent } from './submissions-tab/cards-submissions-tab.component';
import { CardsDropsTabComponent } from './drops-tab/cards-drops-tab.component';
import { CardsRewardsTabComponent } from './rewards-tab/cards-rewards-tab.component';
import { CardsCatalogTabComponent } from './catalog-tab/cards-catalog-tab.component';

@Component({
  selector: 'app-cards',
  imports: [
    TranslocoModule,
    CardsRunsTabComponent,
    CardsStudioTabComponent,
    CardsSpawnsTabComponent,
    CardsCalendarTabComponent,
    CardsSeedsTabComponent,
    CardsBattlesTabComponent,
    CardsSubmissionsTabComponent,
    CardsDropsTabComponent,
    CardsRewardsTabComponent,
    CardsCatalogTabComponent
  ],
  templateUrl: './cards.component.html',
  styleUrl: './cards.component.scss'
})
export class CardsComponent {
  currentTab = signal<string>('runs');

  selectTab(tab: string): void {
    this.currentTab.set(tab);
  }
}
